__webpack_require__.p = "https://de.knowledgesearchadmin.thomsonreuters.com/";